import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Beaker, Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface BetaNoticeProps {
  variant?: "beta" | "info" | "historical";
  title?: string;
  description?: string;
  className?: string;
}

export const BetaNotice = ({ 
  variant = "beta", 
  title,
  description,
  className 
}: BetaNoticeProps) => {
  const getVariantContent = () => {
    switch (variant) {
      case "beta":
        return {
          icon: Beaker,
          defaultTitle: "Beta Feature",
          defaultDescription: "This feature is currently in beta testing. You may encounter bugs or incomplete functionality.",
          bgColor: "bg-yellow-500/10 border-yellow-500/50",
          textColor: "text-yellow-600 dark:text-yellow-400",
          iconColor: "text-yellow-600 dark:text-yellow-400",
        };
      case "historical":
        return {
          icon: Info,
          defaultTitle: "Historical Archive",
          defaultDescription: "BeatBattle is primarily designed for exploring historical music competitions and archived playlists from past leagues.",
          bgColor: "bg-blue-500/10 border-blue-500/50",
          textColor: "text-blue-600 dark:text-blue-400",
          iconColor: "text-blue-600 dark:text-blue-400",
        };
      case "info":
        return {
          icon: Info,
          defaultTitle: title || "Notice",
          defaultDescription: description || "",
          bgColor: "bg-blue-500/10 border-blue-500/50",
          textColor: "text-blue-600 dark:text-blue-400",
          iconColor: "text-blue-600 dark:text-blue-400",
        };
    }
  };

  const content = getVariantContent();
  const Icon = content.icon;

  return (
    <Alert className={cn(content.bgColor, content.textColor, className)}>
      <Icon className={cn("h-4 w-4", content.iconColor)} />
      <AlertTitle className={content.textColor}>
        {title || content.defaultTitle}
      </AlertTitle>
      <AlertDescription className={content.textColor}>
        {description || content.defaultDescription}
      </AlertDescription>
    </Alert>
  );
};

